export default "__VITE_ASSET__DgAOAImj__"